import { content } from '../content';

const AboutSection = () => {
  return (
    <section id="about" className="py-20 lg:py-28 bg-[#FCF9F5]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Image with warm overlay */}
          <div className="order-1 lg:order-1">
            <div className="relative aspect-[3/4] overflow-hidden rounded-2xl shadow-xl">
              <img
                src="/images/heise-bio-pic.png"
                alt={content.about.name}
                className="w-full h-full object-cover"
              />
              {/* Warm overlay to match video carousel */}
              <div className="absolute inset-0 bg-gradient-to-br from-amber-500/10 via-transparent to-purple-500/10 mix-blend-overlay"></div>
            </div>
          </div>

          {/* Content */}
          <div className="order-2 lg:order-2 space-y-6">
            <div>
              <h2 className="text-4xl lg:text-5xl serif font-light text-gray-900 mb-2">
                {content.about.name}
              </h2>
              <p className="text-lg text-purple-600 font-medium mb-1">
                {content.about.title}
              </p>
              <p className="text-base text-gray-600 font-medium">
                {content.about.credentials}
              </p>
            </div>

            <div className="space-y-5 text-gray-600 leading-relaxed text-lg">
              {content.about.bio.map((paragraph, index) => (
                <p key={index} className={index === content.about.bio.length - 1 ? "text-xl text-gray-700 font-light italic pt-2" : ""}>
                  {paragraph}
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;